const langAuthOktaFactorSms = {
	text_explication_type_phone_number: {
		tag: 'auth.okta_factor_sms.text_explication_type_phone_number',
		fr: 'Veuillez saisir ci-dessous le n° de mobile sur lequel vous souhaitez recevoir le SMS contenant le code de vérification.',
		en: 'Please enter below the mobile number on which you wish to receive the SMS containing the verification code.',
	},
	field_label_country: {
		tag: 'auth.okta_factor_sms.field_label_country',
		fr: 'Pays',
		en: 'Country',
	},
	field_label_phone: {
		tag: 'auth.okta_factor_sms.field_label_phone',
		fr: 'N° de mobile',
		en: 'Phone number',
	},
	btn_submit_phone: {
		tag: 'auth.okta_factor_sms.btn_submit_phone',
		fr: 'Recevoir le code',
		en: 'Receive code',
	},
	error_country_required: {
		tag: 'auth.okta_factor_sms.error_country_required',
		fr: 'Veuillez selectionner le pays',
		en: 'Please, select the country',
	},
	error_phone_required: {
		tag: 'auth.okta_factor_sms.error_phone_required',
		fr: 'Veuillez saisir un n° de téléphone mobile',
		en: 'Please, type a mobile phone number',
	},
	error_phone_too_short: {
		tag: 'auth.okta_factor_sms.error_phone_too_short',
		fr: 'Le n° de téléphone saisi est trop court',
		en: 'The mobile phone number is too short',
	},
	error_phone_api: {
		tag: 'auth.okta_factor_sms.error_phone_api',
		fr: "Le n° de mobile n'est pas valide ou vous avez déjà effectué une demande dans lors 30 dernières secondes",
		en: 'The mobile number is not valid or you have already made a request in the last 30 seconds',
	},

	text_explication_type_pass_code: {
		tag: 'auth.okta_factor_sms.text_explication_type_pass_code',
		fr: 'Veuillez saisir le code de vérification que vous venez de recevoir par SMS sur votre n° de mobile <strong>{{phoneNumber}}</strong>',
		en: 'Please enter the verification code you just received via SMS to your mobile number <strong>{{phoneNumber}}</strong>',
	},
	field_label_pass_code: {
		tag: 'auth.okta_factor_sms.field_label_pass_code',
		fr: 'Code de vérification',
		en: 'Verification code',
	},
	btn_submit_pass_code: {
		tag: 'auth.okta_factor_sms.btn_submit_pass_code',
		fr: 'Vérifier',
		en: 'Verify',
	},
	btn_submit_resend_code: {
		tag: 'auth.okta_factor_sms.btn_submit_resend_code',
		fr: 'Recevoir un nouveau code',
		en: 'Receive a new code',
	},
	error_pass_code_need_6_digits: {
		tag: 'auth.okta_factor_sms.error_pass_code_need_6_digits',
		fr: 'Le code de vérification doit contenir 6 chiffres',
		en: 'The verification code must contain 6 digits',
	},
	error_pass_code_check_api: {
		tag: 'auth.okta_factor_sms.error_pass_code_check_api',
		fr: 'Le code de vérification ne semble pas correct ou a expiré. Vous pouvez demander un nouveau code si nécessaire.',
		en: 'The verification code does not appear to be correct or has expired. You can request a new code if necessary.',
	},
	error_pass_code_resend_api: {
		tag: 'auth.okta_factor_sms.error_pass_code_resend_api',
		fr: "Impossible d'envoyer un nouveau code",
		en: 'Unable to resend a new code',
	},
};

export default langAuthOktaFactorSms;
